import React, { useState, useEffect } from "react";
import { bool, shape } from "prop-types";
import Heading from "pages/_components/Heading";
import { selectors as echeqRuleSelectors } from "reducers/echeqRule";
import { connect } from "react-redux";
import { ConditionsDrawer, Button, Box, FormattedAmount } from "@ui-kit/components/index.es";
import * as i18n from "util/i18n";
import FormattedDate from "pages/_components/FormattedDate";
import Hint from "pages/_components/hints/Hint";
import { getCurrencyIso } from "util/cbuCmf";
import { selectors } from "reducers/echeqRules";
import * as configUtils from "util/config";

const FORM_ID = "manage.echeq.rules.create.table.header";
const ACTIONS_W_ACCOUNT = ["CHARGE", "DISCOUNT"];
const ACTIONS_WOUT_ACCOUNT = ["ADMIT", "PAY"];
const CreateEcheqRuleTransactionData = (props) => {
    const [showDrawer, setshowDrawer] = useState(false);
    const [conditionsDrawer, setConditionsDrawer] = useState([]);

    const {
        transactionData,
        fetching,
        summarySelectedRule: { selectedRule },
    } = props;
    const currencyPossibles = {
        "840": "USD",
        "032": "ARS",
    };
    let currency;
    let currencyCode;
    const account = transactionData?.extendedData ? JSON.parse(transactionData.extendedData)?.account : null;
    const ruleAction = transactionData?.data?.action;
    if (
        ACTIONS_WOUT_ACCOUNT.includes(ruleAction?.value) ||
        (ACTIONS_WOUT_ACCOUNT.includes(ruleAction) && transactionData?.data?.actionType === "delete")
    ) {
        currencyCode = transactionData?.data?.currency ?? selectedRule?.currency;
        currency = currencyPossibles[currencyCode] || "";
    }
    if (
        ACTIONS_W_ACCOUNT.includes(ruleAction?.value) ||
        (ACTIONS_W_ACCOUNT.includes(ruleAction) && transactionData?.data?.actionType === "delete")
    ) {
        currency = getCurrencyIso(account);
    }
    useEffect(() => {
        const conditions = transactionData?.data?.conditions?.map((item) => {
            const newLabel = configUtils.getBoolean(
                "frontend.show.echeqRules.contactsMassiveSelection.functionalities",
                false,
            );
            let valueItem = item?.value;
            let title = i18n.get(`manage.echeq.rules.message.${item.type}`);
            if (item.type === "ISSUER") {
                title = newLabel
                    ? i18n.get(`manage.echeq.rules.message.new.${item.type}`)
                    : i18n.get(`manage.echeq.rules.message.${item.type}`);

                title = `${title} (${i18n.get(`manage.echeq.rules.message.${item.operator}`)})`;
                valueItem =
                    item.operator === "ALL"
                        ? i18n.get("manage.echeq.rules.message.value.ALL")
                        : valueItem
                              ?.split("|")
                              .map((pair) => {
                                  const [cuit, environment] = pair.split(";");
                                  return `${environment} - CUIL/CUIT/CDI ${cuit}`;
                              })
                              .join("\n");
            }
            if (item.type === "AMOUNT") {
                const operatorMessage = i18n.get(`manage.echeq.rules.message.${item.operator}`);
                title = `${title} (${operatorMessage})`;
                valueItem = valueItem
                    .split("|")
                    .map((amount, i, array) => (
                        <FormattedAmount
                            key={amount}
                            variant="body2"
                            currency={currency}
                            amount={amount}
                            suffix={i === 0 && array.length !== 1 ? " - " : ""}
                        />
                    ));
            }
            if (item.type === "RECEIVED_BY") {
                valueItem = valueItem.split("|").reduce((acc, curr, i) => {
                    const label = i18n.get(`manage.echeq.rules.message.${curr}`);
                    return `${acc}${i !== 0 ? "\n" : ""}${label}`;
                }, "");
            }
            return {
                title,
                value: valueItem,
            };
        });
        setConditionsDrawer(conditions);
    }, []);

    return (
        <>
            {conditionsDrawer && !fetching ? (
                <ConditionsDrawer
                    conditionsData={conditionsDrawer}
                    setOpen={setshowDrawer}
                    text={i18n.get("echeqs.rule.list.card.context.conditions.description", "", {
                        RULE_NAME: transactionData?.data?.name,
                    })}
                    isVisible={showDrawer && conditionsDrawer}
                />
            ) : null}

            {transactionData?.idTransaction && (
                <>
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label={`${FORM_ID}.voucher`}
                        data={transactionData.idTransaction.substring(0, 8).toUpperCase()}
                    />

                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label={`${FORM_ID}.dateCreate`}
                        data={
                            <p className="data-desc m-0">
                                <FormattedDate date={transactionData?.data?.creationDate} dateFormat="dd/MM/yyyy" />
                            </p>
                        }
                    />
                    {transactionData?.data?.updateDate && (
                        <Heading.DataGroup
                            containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                            labelClassName="data-label-medium"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.dateUpdate`}
                            data={
                                <p className="data-desc m-0">
                                    <FormattedDate date={transactionData?.data?.updateDate} dateFormat="dd/MM/yyyy" />
                                </p>
                            }
                        />
                    )}
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label={`${FORM_ID}.name`}
                        data={transactionData?.data?.name}
                    />
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label={`${FORM_ID}.nroRule`}
                        data={transactionData?.data?.numberRule ? transactionData?.data?.numberRule : "-"}
                    />
                    <Heading.DataGroup
                        containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                        labelClassName="data-label-medium"
                        dataClassName="data-desc"
                        label={`${FORM_ID}.action`}
                        data={
                            ["create", "copy", "modify"].includes(transactionData?.data?.actionType)
                                ? ruleAction?.label
                                : i18n.get(`manage.echeq.rules.message.${ruleAction}`)
                        }
                    />
                    {["DISCOUNT", "PAY"].includes(ruleAction?.value) && (
                        <Heading.DataGroup
                            containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                            labelClassName="data-label-medium"
                            dataClassName="data-desc"
                            label={`${FORM_ID}.beneficiary`}
                            data={
                                ruleAction?.value === "DISCOUNT"
                                    ? i18n.get("global.bankName")
                                    : transactionData.data?.beneficiary?.name
                            }
                        />
                    )}
                    {ruleAction?.value === "PAY" && (
                        <>
                            <Heading.DataGroup
                                containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                                labelClassName="data-label-medium"
                                dataClassName="data-desc"
                                label={`${FORM_ID}.documentType`}
                                data={transactionData.data?.beneficiary?.document}
                            />
                            <Heading.DataGroup
                                containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                                labelClassName="data-label-medium"
                                dataClassName="data-desc"
                                label={`${FORM_ID}.address`}
                                data={transactionData.data?.address}
                            />
                        </>
                    )}
                    {["DISCOUNT", "PAY"].includes(ruleAction?.value) && (
                        <>
                            <Heading.DataGroup
                                containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                                labelClassName="data-label-medium"
                                dataClassName="data-desc"
                                label={`${FORM_ID}.reference`}
                                data={transactionData.data?.reference}
                            />
                            <Heading.DataGroup
                                containerClassName="transaction-ticket-detail data-wrapper-flex space-between"
                                labelClassName="data-label-medium"
                                dataClassName="data-desc"
                                label={`${FORM_ID}.referenceValue`}
                                data={transactionData.data?.referenceValue}
                            />
                        </>
                    )}
                    <Box flex align="center" justify="center" my={12}>
                        <Button
                            aria-label="Ver condiciones"
                            text="VER CONDICIONES"
                            variant="text"
                            size="Large"
                            type="button"
                            onClick={() => setshowDrawer(true)}
                        />
                    </Box>
                    {["enable", "modify", "copy"].includes(transactionData.data.actionType) && (
                        <Box flex align="center" justify="center" my={20}>
                            <Hint
                                defaultValue={i18n.get("echeqs.rule.actionConfirmation.tooltip")}
                                styleText={{
                                    maxWidth: "35rem",
                                }}
                                classNameGroup="transfer__text-hint"
                                styleDiv={{ marginLeft: "0.5rem" }}
                                styleImage={{ alignSelf: "center", display: "flex" }}
                                classNameHintP="font-weight-normal my-0"
                                alwaysShowMessage
                            />
                        </Box>
                    )}
                </>
            )}
        </>
    );
};

CreateEcheqRuleTransactionData.propTypes = {
    transactionData: shape({}).isRequired,
    fetching: bool.isRequired,
    summarySelectedRule: shape({}),
};
CreateEcheqRuleTransactionData.defaultProps = {
    summarySelectedRule: {
        pageNumber: null,
        totalPages: null,
    },
};

const mapStateToProps = (state) => ({
    transactionData: echeqRuleSelectors.getEcheqRuleTransactionData(state),
    summarySelectedRule: selectors.getSummarySelectedRule(state),
});

export default connect(mapStateToProps)(CreateEcheqRuleTransactionData);
